import CommunitiesLayout from "./Layout";
import ExploreApp from "../../communities/pages/explore/App";

function Explore() {
  return <ExploreApp />;
}
Explore.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>;
export default Explore;
